import React, { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import loaderImage from "../Loder/1.png";
import loaderImage2 from "../Loder/2.png";

gsap.registerPlugin(ScrollTrigger);

const ElevatorLoader = ({ onFinish }) => {
  const [showLoader, setShowLoader] = useState(true);
  const leftDoorRef = useRef(null);
  const rightDoorRef = useRef(null);

  useEffect(() => {
    // Show closed doors briefly (300ms), then smoothly slide open (1.2s)
    const tl = gsap.timeline({
      delay: 0.3,
      onComplete: () => {
        setShowLoader(false);
        if (onFinish) onFinish();
      },
    });

    tl.to(
      leftDoorRef.current,
      {
        x: "-100%",
        duration: 1.2,
        ease: "power2.inOut",
      },
      0
    ).to(
      rightDoorRef.current,
      {
        x: "100%",
        duration: 1.2,
        ease: "power2.inOut",
      },
      0
    );

    return () => tl.kill();
  }, [onFinish]);

  return (
    showLoader && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          background: "transparent",
          zIndex: 99999,
          pointerEvents: "none",
        }}
      >
        {/* Left Door */}
        <div
          ref={leftDoorRef}
          style={{
            position: "absolute",
            width: "50%",
            height: "100%",
            backgroundColor: "silver",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            left: 0,
            borderRight: "2px solid black",
            willChange: "transform",
          }}
        >
          <div
            style={{
              width: "20vw",
              maxWidth: "250px",
              height: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={loaderImage}
              alt="Elevator Door"
              style={{
                height: "auto",
                position: "absolute",
                right: "0.5%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>

        {/* Right Door */}
        <div
          ref={rightDoorRef}
          style={{
            position: "absolute",
            width: "50%",
            height: "100%",
            backgroundColor: "silver",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            right: 0,
            borderLeft: "2px solid black",
            willChange: "transform",
          }}
        >
          <div
            style={{
              width: "20vw",
              maxWidth: "250px",
              height: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={loaderImage2}
              alt="Elevator Door"
              style={{
                height: "auto",
                position: "absolute",
                left: "0.5%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default ElevatorLoader;